module.exports = __webpack_public_path__ + "media/select_image.8ad8c3b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/cloud/server/select_image.png
// module id = 742
// module chunks = 2